const STORAGE_KEY = 'sktech.editor';
const LEGACY = 'legacy';

function readStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

// `?editor=legacy` pins the old Editor.js implementation for this browser, `?editor=tiptap` clears
// it again. Read once on module load so the flag survives navigation without the query string.
(function applyQueryOverride(): void {
  try {
    const storage = readStorage();
    if (!storage) {
      return;
    }
    // Parsed rather than substring-matched, so an unrelated `?redirect=/x?editor=legacy` never
    // flips the flag.
    const editor = new URLSearchParams(window.location.search || '').get('editor');
    if (editor === LEGACY) {
      storage.setItem(STORAGE_KEY, LEGACY);
    } else if (editor === 'tiptap') {
      storage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Private mode / SSR — the flag simply stays off.
  }
})();

/** True while this browser is pinned to the legacy Editor.js editor. */
export function isLegacyEditor(): boolean {
  try {
    return readStorage()?.getItem(STORAGE_KEY) === LEGACY;
  } catch {
    return false;
  }
}
